var toString = require('../to-string');

var lowerFirst = function lowerFirst(value) {
  var str = toString(value);
  return str.charAt(0).toLowerCase() + str.substring(1);
};

module.exports = lowerFirst;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/string/lower-first.js
// module id = 106
// module chunks = 0 1 2